/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
import NativeEventEmitter from '../../vendor/react-native/NativeEventEmitter';
export default NativeEventEmitter;